<template lang="pug">
.goal-details.content
  .goal(:style="{'background-color': goal.color}") {{goal.title}}
  p {{goal.description}}
  ul
    li(v-for="c in goal.children") {{c.title}}
</template>

<script>
export default {
  props: ['goal']
  
}
</script>

<style scoped>
.goal-details {
  background-color: white;
  z-index: 900;
  margin: 0;
  padding: 24px;
}
.goal-details .goal {
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
  display: inline-block;
}
</style>
